/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListOperations200ResponsePaging } from './ListOperations200ResponsePaging';
import {
    ListOperations200ResponsePagingFromJSON,
    ListOperations200ResponsePagingFromJSONTyped,
    ListOperations200ResponsePagingToJSON,
    ListOperations200ResponsePagingToJSONTyped,
} from './ListOperations200ResponsePaging';
import type { ListConditions200ResponseItemsInner } from './ListConditions200ResponseItemsInner';
import {
    ListConditions200ResponseItemsInnerFromJSON,
    ListConditions200ResponseItemsInnerFromJSONTyped,
    ListConditions200ResponseItemsInnerToJSON,
    ListConditions200ResponseItemsInnerToJSONTyped,
} from './ListConditions200ResponseItemsInner';

/**
 * 
 * @export
 * @interface ListConditions200Response
 */
export interface ListConditions200Response {
    /**
     * 
     * @type {Array<ListConditions200ResponseItemsInner>}
     * @memberof ListConditions200Response
     */
    items: Array<ListConditions200ResponseItemsInner>;
    /**
     * 
     * @type {ListOperations200ResponsePaging}
     * @memberof ListConditions200Response
     */
    paging: ListOperations200ResponsePaging;
}

/**
 * Check if a given object implements the ListConditions200Response interface.
 */
export function instanceOfListConditions200Response(value: object): value is ListConditions200Response {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('paging' in value) || value['paging'] === undefined) return false;
    return true;
}

export function ListConditions200ResponseFromJSON(json: any): ListConditions200Response {
    return ListConditions200ResponseFromJSONTyped(json, false);
}

export function ListConditions200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListConditions200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ListConditions200ResponseItemsInnerFromJSON)),
        'paging': ListOperations200ResponsePagingFromJSON(json['paging']),
    };
}

export function ListConditions200ResponseToJSON(json: any): ListConditions200Response {
    return ListConditions200ResponseToJSONTyped(json, false);
}

export function ListConditions200ResponseToJSONTyped(value?: ListConditions200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(ListConditions200ResponseItemsInnerToJSON)),
        'paging': ListOperations200ResponsePagingToJSON(value['paging']),
    };
}

